export const PageTitles = {
  purchase: 'Get Your Chef Ami Purchase',
  plan: 'Choose Plan - Chef Ami',
  payment: 'Checkout - Chef Ami',
  notFound: 'Error - Chef Ami',
} as const;

export const SiteStorage = {
  NEWORDERDETAILS: 'new_order_details',
} as const;

/**
 * New order page image paths.
 * These are served from the `public/img/` folder (available at `/img/` at runtime).
 */
export const ImagePaths = {
  STEP_1_ICON: '/img/step-1.icon.svg',
  STEP_2_ICON: '/img/step-2.icon.svg',
  STEP_3_ICON: '/img/step-3.icon.svg',
  STEP_4_ICON: '/img/step-4.icon.svg',
  LOCATION_ICON: '/img/location.svg',
  PLAN_BANNER: '/img/plan-banner.jpg',
  PLAN_BANNER_MOBILE: '/img/plan-banner-mobile.jpg',
  INFO_ICON: '/img/info-icon.svg',
  ARROW_UP_WHITE_ICON: '/img/arrow-up-white-icon.svg',
  ARROW_DOWN_ICON: '/img/arrow-down-icon.svg',
  CALENDAR_ICON: '/img/calendar-icon.svg',
  MONEY_EXCHANGE_ICON: '/img/money-exchange-icon.svg',
  CHECKMARK_ICON: '/img/checkmark-icon.svg',
  CHECKED_BOX_ICON: '/img/checked-box.svg',
  REFUND_BOX_ICON: '/img/refund-box-icon.jpg',
  SECURE_ICON: 'img/secure-icon.jpeg',
  CREDIT_CARDS_ICON: 'img/credit-cards.jpeg',
} as const;
